import { ApiContent } from '@core/services/media-library/media-library.interface';
import { UiThumbnailContent } from '@features/media-library/interfaces';
import { UploadFile } from '@ntv360/component-pantry';

/**
 * Determines whether a file is of type image or video.
 *
 * @param {File} file - The file object to check.
 * @returns {"image" | "video" | "unknown"} The media type of the file.
 */
export function getMediaType(file: ApiContent | UiThumbnailContent | UploadFile | File) {
    const mimeType =
        'mimeType' in file && file.mimeType
            ? file.mimeType
            : 'type' in file
              ? file.type
              : 'fileType' in file
                ? file.fileType
                : '';
    const ext =
        'name' in file
            ? file.name?.split('.').pop()?.toLowerCase()
            : 'fileName' in file
              ? file.fileName?.split('.').pop()?.toLowerCase()
              : 'extension' in file
                ? file.extension
                : '';

    const imageExts = [
        'jpg',
        'jpeg',
        'png',
        'gif',
        'webp',
        'svg',
        'bmp',
        'ico',
        'tiff',
        'avif',
        'heic',
    ];
    const videoExts = ['mp4', 'mov', 'avi', 'mkv', 'webm', 'flv', 'wmv', 'm4v', 'ogv', '3gp'];

    if (mimeType.startsWith('image/') || imageExts.includes(ext ?? '')) return 'image';
    if (mimeType.startsWith('video/') || videoExts.includes(ext ?? '')) return 'video';
    return 'unknown';
}
